export default "__VITE_ASSET__$D5Ks5yC__"